/** Verify the auth code sent to the user's email and entered by the user */
export const sessionEmailAuthVerifySpec = {
    uri: '/t/[tenant]/session/email-auth-verify',
    method: 'POST',
    allowAnonymous: true,
};
